import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { MogilevRegionWithLoader } from './loaders';
import { getCitiesByRegion } from '../../../actions/city/thunks';
import { RegionTypes } from '../../../types/Models/City/City';

export const MogilevRegion = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCitiesByRegion(RegionTypes.MOGILEV));
    }, []);

    return <MogilevRegionWithLoader />;
};
